import isFunction from 'lodash/isFunction';
import getConfig from 'next/config';

import { bugsnag } from 'shared/utils/services/bugsnag';

declare global {
  interface Window {
    gtag: any;
  }
}

// https://support.google.com/google-ads/answer/6095821?hl=en&ref_topic=3165803
export const trackGtagConversion = (options: any = {}) => {
  const {
    publicRuntimeConfig: { GOOGLE_AW_CONVERSION_ID },
  } = getConfig();

  if (typeof window === 'undefined' || !isFunction(window.gtag) || !GOOGLE_AW_CONVERSION_ID) {
    bugsnag(
      `trackGtagConversion: window.gtag is not a function or missing GOOGLE_AW_CONVERSION_ID `,
      {
        context: 'tracking',
        severity: 'info',
      },
    );

    return;
  }

  try {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_AW_CONVERSION_ID as string}/ybVvCKeZgIoBEMjn3aED`,
      ...options,
    });
  } catch (error) {
    bugsnag(error, { context: 'tracking', severity: 'info' });
  }
};
